import { Helmet } from "react-helmet"
import { texts } from "../../texts"

export const CategoriesHelmet = () => {
    return (
        <Helmet>
            <title>{texts.catalogue.title}</title>
        </Helmet>
    )
}